$(function () {
    var printOutBtn = $('#printOutBtn');
    printOutBtn.click(function () {
        window.print();
        return false;
    })
});
